import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

import {
  Row,
  Typography,
  Col,
  Collapse,
  Button,
  Spin,
  Divider,
  Empty,
  Form,
} from "antd";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { labelConfig, apiConfig } from "../../../../customer.config";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import EditPersonalInfo from "./EditContactInfo";
import NewCounterParty from "./NewCounterParty";

const { Text, Title } = Typography;
const { Panel } = Collapse;

function CounterPartyInfoTab(props) {
  const { currentCustomerObj, customerDetails, userData } = props;
  const { session } = userData;
  const [counterPartyDetails, setCounterPartyDetails] = useState(null);
  const [counterPartyExists, setCounterPartyExists] = useState(false);
  const [useForm] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // console.log(customerDetails);
    getClientCounterParty();
  }, []);

  const getClientCounterParty = () => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.Counterparty}/${currentCustomerObj.id}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        setCounterPartyExists(false);
        setCounterPartyDetails(null);
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);
        setCounterPartyExists(true);
        const objList = res;
        setCounterPartyDetails(objList);
        useForm.setFieldsValue({
          name: customerDetails.displayName ?? "",
          contactPhoneNo: objList?.contactPhoneNo ?? "",
          contactEmail: objList?.contactEmail ?? "",
          creditRiskRating: objList?.creditRiskRating ?? "",
        });
      }
    });
  };

  // Function to refresh data after adding a new counterparty
  const refreshCounterPartyData = () => {
    getClientCounterParty();
  };

  return (
    <Spin spinning={isLoading} tip="Loading..." size="large">
      {!counterPartyExists && (
        <>
          <Row justify="center" style={{ marginBottom: 20 }}>
            <Col>
              <NewCounterParty
                currentCustomerObj={currentCustomerObj}
                userData={userData}
                refreshList={refreshCounterPartyData}
              />
            </Col>
          </Row>
          <Divider style={{ marginTop: 10, marginBottom: 30 }} />
          <Row justify="center">
            <Col span={16}>
              <Empty
                description="No Counterparty Information Found"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            </Col>
          </Row>
        </>
      )}

      {counterPartyExists && (
        <>
          <Divider style={{ marginTop: 10, marginBottom: 30 }} />

          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <CounterPartyContactInfo
                currentCustomerObj={currentCustomerObj}
                customerDetails={customerDetails}
                counterPartyDetails={counterPartyDetails}
                userData={userData}
                form={useForm}
              />
            </Col>

            <Col span={12} style={{ padding: "0px 8px" }}>
              <CounterPartyInstitutionInfo
                currentCustomerObj={currentCustomerObj}
                customerDetails={customerDetails}
                counterPartyDetails={counterPartyDetails}
                userData={userData}
              />
            </Col>
          </Row>
        </>
      )}
    </Spin>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CounterPartyInfoTab);

function CounterPartyContactInfo(props) {
  const {
    currentCustomerObj,
    customerDetails,
    counterPartyDetails,
    userData,
    form,
  } = props;

  console.log(counterPartyDetails)
  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.contactInfo}
          </Title>
        }
        key="1"
      >
        <Row
          style={{
            marginBottom: "8px",
          }}
        >
          <EditPersonalInfo
            currentCustomerObj={currentCustomerObj}
            userData={userData}
            customerDetails={customerDetails}
            useForm={form}
            // refreshList={getClientLimit}
          />
        </Row>

        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.fullName}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {customerDetails.displayName
                  ? customerDetails.displayName
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.contactEmail}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.contactEmail
                  ? counterPartyDetails.contactEmail
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.contactPhoneNo}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.contactPhoneNo
                  ? counterPartyDetails.contactPhoneNo
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.status}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.status
                  ? counterPartyDetails.status?.value
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}

function CounterPartyInstitutionInfo(props) {
  const { currentCustomerObj, counterPartyDetails, userData } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.institutionInfo}
          </Title>
        }
        key="1"
      >
        <Row
          style={{
            marginBottom: "8px",
          }}
        >
          {/* <EditKYCBusinessInfo
            currentCustomerObj={currentCustomerObj}
            userData={userData}
            counterPartyDetails={counterPartyDetails}
            // refreshList={getClientLimit}
          /> */}
        </Row>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.bankName} </Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.bankName
                  ? counterPartyDetails.bankName
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.centralBankCode}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {" "}
                {counterPartyDetails?.centralBankCode === undefined
                  ? "-"
                  : String(counterPartyDetails.centralBankCode)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.institutionCode}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.institutionCode
                  ? counterPartyDetails.institutionCode
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.swiftCode}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {" "}
                {counterPartyDetails?.swiftCode === undefined
                  ? "-"
                  : String(counterPartyDetails.swiftCode)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.creditRiskRating}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.creditRiskRating
                  ? counterPartyDetails.creditRiskRating
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>

        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.maxLimitAmountLcy}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.maxLimitAmountLcy === undefined
                  ? "-"
                  : String(counterPartyDetails.maxLimitAmountLcy)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.currentLimitUtilizationLcy}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.currentLimitUtilizationLcy === undefined
                  ? "-"
                  : String(counterPartyDetails.currentLimitUtilizationLcy)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.placementDealAccountLcy}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.externalDealAccountNumber === undefined
                  ? "-"
                  : String(counterPartyDetails.externalDealAccountNumber)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.createdDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.createdDate === undefined
                  ? "-"
                  : String(
                      BOM.FormatArrayDate(
                        counterPartyDetails.createdDate,
                        "only-date"
                      )
                    )}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.lastModifiedDate} </Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {counterPartyDetails?.lastModifiedDate === undefined
                  ? "-"
                  : String(counterPartyDetails.lastModifiedDate)}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}
